import React from 'react';
import { ArrowRight, Heart, Star, ShieldCheck, Mail, Download } from 'lucide-react';
import { useOrderBumps, getActiveCheckoutUrl, getOrderTotal, getItemCount } from '../../hooks/useOrderBumps';
interface CTASectionWithCheckoutProps {
  checkoutUrl: string;
  displayPrice?: string;
}
export function CTASectionWithCheckout({
  checkoutUrl,
  displayPrice = '$19.999'
}: CTASectionWithCheckoutProps) {
  const {
    bump1Selected,
    bump2Selected
  } = useOrderBumps();
  const activeCheckoutUrl = getActiveCheckoutUrl(checkoutUrl, bump1Selected, bump2Selected);
  const orderTotal = getOrderTotal(bump1Selected, bump2Selected);
  const itemCount = getItemCount(bump1Selected, bump2Selected);
  return <section className="py-24 relative overflow-hidden" style={{
    backgroundColor: '#F8F6F1'
  }} data-id="element-599">
      {/* Decorative circles */}
      <div className="absolute top-0 left-0 w-[500px] h-[500px] rounded-full blur-[100px] -translate-x-1/3 -translate-y-1/3" style={{
      backgroundColor: 'rgba(109,170,127,0.12)'
    }} data-id="element-600"></div>
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] rounded-full blur-[100px] translate-x-1/3 translate-y-1/3" style={{
      backgroundColor: 'rgba(192,57,43,0.08)'
    }} data-id="element-601"></div>
      <div className="absolute top-1/2 left-1/2 w-[300px] h-[300px] rounded-full blur-[80px] -translate-x-1/2 -translate-y-1/2" style={{
      backgroundColor: 'rgba(47,93,80,0.08)'
    }} data-id="element-602"></div>

      <div className="container mx-auto px-4 relative z-10 text-center max-w-4xl" data-id="element-603">
        <h2 className="text-3xl md:text-5xl font-bold mb-12" style={{
        color: '#2F5D50'
      }} data-id="element-604">
          🐾 ANTES VS. DESPUÉS
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-605">
          <div className="bg-white/80 backdrop-blur-sm p-8 rounded-2xl border shadow-sm" style={{
          borderColor: 'rgba(192,57,43,0.2)'
        }} data-id="element-606">
            <h3 className="text-xl font-bold mb-6" style={{
            color: '#C0392B'
          }} data-id="element-607">
              ANTES
            </h3>
            <ul className="space-y-4 text-left" data-id="element-608">
              <li className="flex items-center gap-3 text-gray-700" data-id="element-609">
                <span style={{
                color: '#C0392B'
              }} data-id="element-610">
                  ❌
                </span>{' '}
                Alimentación inflamatoria
              </li>
              <li className="flex items-center gap-3 text-gray-700" data-id="element-611">
                <span style={{
                color: '#C0392B'
              }} data-id="element-612">
                  ❌
                </span>{' '}
                Malestar constante
              </li>
              <li className="flex items-center gap-3 text-gray-700" data-id="element-613">
                <span style={{
                color: '#C0392B'
              }} data-id="element-614">
                  ❌
                </span>{' '}
                Poco ánimo
              </li>
              <li className="flex items-center gap-3 text-gray-700" data-id="element-615">
                <span style={{
                color: '#C0392B'
              }} data-id="element-616">
                  ❌
                </span>{' '}
                Riesgos invisibles
              </li>
            </ul>
          </div>

          <div className="bg-white p-8 rounded-2xl border-2 shadow-lg relative overflow-hidden" style={{
          borderColor: '#6DAA7F'
        }} data-id="element-617">
            <div className="absolute top-0 right-0 w-20 h-20 rounded-full blur-2xl opacity-30 -translate-y-1/2 translate-x-1/2" style={{
            backgroundColor: '#6DAA7F'
          }} data-id="element-618"></div>
            <h3 className="text-xl font-bold mb-6" style={{
            color: '#2F5D50'
          }} data-id="element-619">
              DESPUÉS
            </h3>
            <ul className="space-y-4 text-left" data-id="element-620">
              <li className="flex items-center gap-3 text-gray-800 font-medium" data-id="element-621">
                <span style={{
                color: '#6DAA7F'
              }} data-id="element-622">
                  ✅
                </span>{' '}
                Menos inflamación
              </li>
              <li className="flex items-center gap-3 text-gray-800 font-medium" data-id="element-623">
                <span style={{
                color: '#6DAA7F'
              }} data-id="element-624">
                  ✅
                </span>{' '}
                Mejor digestión
              </li>
              <li className="flex items-center gap-3 text-gray-800 font-medium" data-id="element-625">
                <span style={{
                color: '#6DAA7F'
              }} data-id="element-626">
                  ✅
                </span>{' '}
                Más energía
              </li>
              <li className="flex items-center gap-3 text-gray-800 font-medium" data-id="element-627">
                <span style={{
                color: '#6DAA7F'
              }} data-id="element-628">
                  ✅
                </span>{' '}
                Mejor calidad de vida
              </li>
            </ul>
          </div>
        </div>

        {/* Guarantee */}
        <div className="p-8 rounded-2xl shadow-sm border max-w-2xl mx-auto mb-12" style={{
        backgroundColor: '#FFF3E0',
        borderColor: '#6DAA7F'
      }} data-id="element-629">
          <div className="flex flex-col items-center gap-4" data-id="element-630">
            <ShieldCheck className="w-12 h-12" style={{
            color: '#2F5D50'
          }} data-id="element-631" />
            <h3 className="text-xl font-bold text-gray-900" data-id="element-632">
              🛡️ GARANTÍA DE 7 DÍAS
            </h3>
            <p className="text-gray-600" data-id="element-633">
              Si no te convence, pides el reembolso dentro de los 7 días y te
              devolvemos toda la plata. Sin enredos. Sin riesgo.
            </p>
          </div>
        </div>

        {/* Delivery Info */}
        <div className="flex flex-wrap justify-center gap-6 mb-12 text-sm font-medium text-gray-600" data-id="element-634">
          <div className="flex items-center gap-2" data-id="element-635">
            <Mail className="w-5 h-5" style={{
            color: '#2F5D50'
          }} data-id="element-636" />
            Te llega al correo de una
          </div>
          <div className="flex items-center gap-2" data-id="element-637">
            <Download className="w-5 h-5" style={{
            color: '#2F5D50'
          }} data-id="element-638" />
            Descarga digital inmediata
          </div>
          <div className="flex items-center gap-2" data-id="element-639">
            <Star className="w-5 h-5" style={{
            color: '#2F5D50'
          }} data-id="element-640" />
            Fácil de aplicar desde hoy
          </div>
        </div>

        <a href={activeCheckoutUrl} target="_blank" rel="noopener noreferrer" className="block w-full md:w-auto mx-auto mb-12" onClick={() => {
        if (typeof window !== 'undefined' && window.fbq) {
          window.fbq('track', 'InitiateCheckout', {
            content_name: '30 Recetas Anti-Inflamatorias para Mascotas',
            content_category: 'E-book',
            value: orderTotal,
            currency: 'COP',
            num_items: itemCount
          });
        }
      }} data-id="element-641">
          <button className="text-white text-xl md:text-2xl font-bold py-6 px-12 rounded-2xl shadow-xl hover:-translate-y-1 transition-all duration-200 flex flex-col items-center justify-center gap-1 w-full group text-center leading-tight" style={{
          background: 'linear-gradient(to right, #F57C00, #e07000)',
          boxShadow: '0 10px 30px rgba(245,124,0,0.35)'
        }} onMouseEnter={e => e.currentTarget.style.background = 'linear-gradient(to right, #E66A00, #cc5f00)'} onMouseLeave={e => e.currentTarget.style.background = 'linear-gradient(to right, #F57C00, #e07000)'} data-id="element-642">
            <span data-id="element-643">COMPRAR AHORA</span>
            <span className="text-base font-semibold opacity-90" data-id="element-644">
              por {displayPrice} COP
            </span>
          </button>
        </a>
        <img src="https://cdn.magicpatterns.com/uploads/bUYjbHt13EreDF1v14FXSq/image.png" alt="Métodos de pago: Nequi, PSE, Bancolombia" className="mx-auto mt-3 h-8 object-contain" data-id="element-645" />

        <div className="bg-white p-8 rounded-2xl shadow-xl border max-w-2xl mx-auto relative" style={{
        borderColor: '#6DAA7F'
      }} data-id="element-646">
          <div className="absolute -top-5 left-1/2 -translate-x-1/2 text-white p-3 rounded-full shadow-lg" style={{
          backgroundColor: '#C0392B'
        }} data-id="element-647">
            <Heart className="w-6 h-6 fill-current" data-id="element-648" />
          </div>
          <h3 className="text-xl font-bold text-gray-900 mt-4 mb-2" data-id="element-649">
            🐶 TU PERRO DEPENDE DE TI
          </h3>
          <p className="text-lg text-gray-700 font-medium italic" data-id="element-650">
            "Él no puede pedir ayuda. Tú sí puedes hacer algo hoy."
          </p>
        </div>
      </div>
    </section>;
}